import { SuccessMessage, ErrorMessage } from '@/app/messages/store'
import { I18nOptions, LocaleMessageDictionary, VueMessageType } from 'vue-i18n'

type Messages = Record<keyof I18nOptions['messages'], LocaleMessageDictionary<VueMessageType>>
type Params = Record<string, unknown>

export default class MessageSender {
    t: (key: string, params?: Params) => string

    constructor (messages: Messages) {
        const i18n = window.VueI18n.createI18n({
            locale: window.config.getLang(),
            fallbackLocale: 'cz',
            messages,
        })

        this.t = i18n.global.t
    }

    sendSuccess (message: string): void {
        window.vueMessagesStore.addMessage(new SuccessMessage(message))
    }

    sendError (message: string, params?: Params): void {
        window.vueMessagesStore.addMessage(new ErrorMessage(this.t(message, params)))
    }
}
